import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m17.8385 2h-11.67704c-.52713-.00002-.98192-.00003-1.35649.03057-.39534.0323-.78856.10362-1.16694.29641-.56449.28762-1.02343.74656-1.31105 1.31105-.19279.37838-.26411.7716-.29641 1.16694-.0306.37457-.03059.82932-.03057 1.35645v11.67708c-.00002.5272-.00003.982.03057 1.3565.0323.3954.10362.7886.29641 1.167.28762.5645.74656 1.0234 1.31105 1.311.37838.1928.7716.2641 1.16694.2964.37457.0306.82933.0306 1.35647.0306h11.67716c.5271 0 .9819 0 1.3564-.0306.3954-.0323.7886-.1036 1.167-.2964.5645-.2876 1.0234-.7465 1.311-1.311.1928-.3784.2641-.7716.2964-1.167.0306-.3745.0306-.8293.0306-1.3564v-11.67716c0-.52714 0-.9819-.0306-1.35647-.0323-.39534-.1036-.78856-.2964-1.16694-.2876-.56449-.7465-1.02343-1.311-1.31105-.3784-.19279-.7716-.26411-1.167-.29641-.3745-.0306-.8293-.03059-1.3565-.03057zm-5.8385 5c.5523 0 1 .44772 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3h-3c-.55228 0-1-.4477-1-1s.44772-1 1-1h3v-3c0-.55228.4477-1 1-1z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }